import { useEffect, useState } from "react";
import { IStudentAllTermCourse } from "../../../../models/student/studentCourceDetail";
import RateTheCourse from "./rateTheCourse";
import { connect, useDispatch } from "react-redux";
import { setStudentCourceDetail } from "../../../../store/slices/student/studentCourceDetailSlice";
import { getStudentCourceDetail } from "../../../../action/student/studentCourceDetailActionCreator";
import ReactModal from "react-modal";
import { getStudentTermDetails } from "../../../../action/student/studentTermDetailsActionCreators";
import { setStudentTermDetail } from "../../../../store/slices/student/studentTermSlice";
import { IStudentTerm } from "../../../../models/student/studentTerm";
import { getCourseRatingDetails } from "../../../../action/student/studentRateCourseActionCreator";
import { Rating } from "react-simple-star-rating";
import FloatingLabelDropDown from "../../../../common-components/floatingdropdown";

const StudentAllTermCources = (props: IStudentAllTermCourse) => {
  const {
    getAllTermCourceDetail,
    studentCourceDetail,
    studentTerms,
    getAllTerms,
    getCourseRateDetails,
    courseRate,
  } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getAllTerms();
  }, []);

  const [studentTerm, setStudentTerm] = useState(studentTerms?.[0]?.id ?? null);

  useEffect(() => {
    if (studentTerms?.length > 0) {
      setStudentTerm(studentTerms[0]?.id);
    }
  }, [studentTerms]);

  const handleClickTabId = (id: number | null) => {
    setStudentTerm(id ?? studentTerms?.[0]?.id);
  };

  useEffect(() => {
    if (studentTerm) {
      getAllTermCourceDetail(studentTerm);
    }
  }, [studentTerm]);

  useEffect(() => {
    return () => {
      dispatch(setStudentCourceDetail([]));
      dispatch(setStudentTermDetail([]));
    };
  }, []);

  const [selectedCourse, setSelectedCourse] = useState<number | null>(
    studentCourceDetail?.cources?.[0]?.id ?? null
  );

  useEffect(() => {
    if (selectedCourse) {
      getCourseRateDetails(selectedCourse);
    }
  }, [selectedCourse]);

  const handleRedirect = () => {
    window.open("https://www.w3schools.com/", "_blank");
  };

  const handleClickId = (id: number | null) => {
    setSelectedCourse(id ?? 0);
  };

  useEffect(() => {
    if (studentCourceDetail?.cources?.length > 0) {
      setSelectedCourse(studentCourceDetail?.cources[0]?.id);
    } else {
      setSelectedCourse(null);
    }
  }, [studentCourceDetail]);

  const [showRateCourse, setShowRateCourse] = useState(false);

  const handleShow = () => setShowRateCourse(true);

  const handleClose = () => setShowRateCourse(false);

  const currentCourse = studentCourceDetail?.cources?.find(
    (c) => c.id === selectedCourse
  );

  const selectedCourseData = studentCourceDetail?.cources?.find(
    (course) => course.id === selectedCourse
  );

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <div className="course-wrap mb-3">
            <div className="tabs course-tab-desktop">
              {studentTerms?.length > 0 &&
                studentTerms.map((Term: IStudentTerm) => (
                  <button
                    key={Term.id}
                    className={`${studentTerm === Term.id ? "active" : ""}`}
                    onClick={() => handleClickTabId(Term.id)}
                  >
                    {Term.name}
                  </button>
                ))}
            </div>
            <div className="tabs course-tab-mobile d-none">
            <FloatingLabelDropDown
              label={"Term"}
              onChange={(e: any) => handleClickTabId(Number(e.target.value))}
              isMandatory={false}
              value={studentTerm}
              name={"termId"}
              optionsList={studentTerms}
              showClear={false}
            />
          </div>
          </div>
        </div>
      </div>
      <div className="row coursetabs show fall2024">
        <div className="course-tab-mobile d-none">
          <FloatingLabelDropDown
            label={"Subject"}
            onChange={(e: any) => handleClickId(Number(e.target.value))}
            isMandatory={false}
            value={selectedCourse}
            name="courseId"
            optionsList={studentCourceDetail?.cources}
            showClear={false}
          />
        </div>
        <div className="col-lg-4 transactions-scroll course-tab-desktop">
          <ul className="course-list">
            {studentCourceDetail?.cources?.map((courses) => (
              <li
                className={`${selectedCourse === courses.id ? "active" : ""}`}
                onClick={() => handleClickId(courses.id)}
              >
                <div className="img">
                  <img src={courses.image} />
                </div>
                <div className="dtls">
                  <h6>{courses.name}</h6>
                  <p>{courses.courseDescription}.</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-lg-8 ">
          <div className="row py-3 adaptheight">
            {selectedCourseData && (
              <>
                <div className="col-lg-3" key={selectedCourseData.id}>
                  <img
                    src={selectedCourseData.image}
                    alt=""
                    className="w-100"
                    style={{ borderRadius: "16px" }}
                  />
                </div>
                <div className="col-lg-9">
                  <div className="d-flex justify-content-between">
                    <div className="desc">
                      <h2 className="fs-5">{selectedCourseData.name}</h2>
                      <div className="d-flex align-items-center">
                        <Rating
                          initialValue={courseRate?.averageRating || 0}
                          size={20}
                          readonly={true}
                          allowFraction={true}
                          fillColor="#948256"
                        />
                        <span className="ms-2">
                          ({courseRate?.totalReviews || 0})
                        </span>
                      </div>
                    </div>
                    <div className="rateus">
                      <button
                        className="btn btn-border p-2"
                        data-bs-toggle="modal"
                        data-bs-target="#ratewrap"
                        onClick={handleShow}
                      >
                        Rate the course
                      </button>
                    </div>
                  </div>
                  <button
                    className="btn btn-primary mt-3"
                    onClick={handleRedirect}
                  >
                    Access your course
                  </button>
                </div>
                <div className="col-lg-12 mt-1">
                  <ul className="courseinst">
                    <li>
                      <div className="img">
                        <img
                          src={selectedCourseData.mentorImage}
                          alt=""
                          onError={(e) => {
                            e.currentTarget.src =
                              "/assets/images/icon/DefaultImage.jpeg";
                          }}
                        />
                      </div>
                      <div className="desc">
                        <label htmlFor="">Instructor</label>
                        <p>{selectedCourseData.mentorName}</p>
                      </div>
                    </li>
                    <li>
                      <div className="img">
                        <img src="/assets/images/icon/schedule.svg" alt="" />
                      </div>
                      <div className="desc">
                        <label htmlFor="">Next Class</label>
                        <p>{selectedCourseData.dateTime}</p>
                      </div>
                    </li>
                    <li>
                      <div className="img">
                        <img src="/assets/images/icon/credit.svg" alt="" />
                      </div>
                      <div className="desc">
                        <label htmlFor="">Credits</label>
                        <p>{selectedCourseData.credits}</p>
                      </div>
                    </li>
                  </ul>
                  <h2 className="mb-2">Course Description</h2>
                  <p>
                    <img
                      src={selectedCourseData.image}
                      alt=""
                      className="r-none"
                      style={{ borderRadius: "16px" }}
                    />
                    {selectedCourseData.courseDescription}
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {currentCourse && (
        <ReactModal
          isOpen={showRateCourse}
          onRequestClose={handleClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
        >
          <RateTheCourse
            setShowRateCourse={handleClose}
            courseId={currentCourse.id}
            name={currentCourse.name}
            getCourseRateDetails={getCourseRateDetails}
          />
        </ReactModal>
      )}
    </>
  );
};

const mapDispatchToProps = {
  getAllTermCourceDetail: (semesterId: number) =>
    getStudentCourceDetail(semesterId),
  getAllTerms: () => getStudentTermDetails(),
  getCourseRateDetails: (courseId: number) => getCourseRatingDetails(courseId),
};

function mapStateToProps(state: any) {
  return {
    studentCourceDetail: state.studentCourceDetail.studentCourceDetail,
    studentTerms: state.studentTermDetail.studentTermDetail,
    courseRate: state.studentCourceRateDetail.rateDetail,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentAllTermCources);
